import React from 'react';

// Angle_double_right
const Adr = () => {
    return(
        <i class="fa fa-angle-double-right" aria-hidden="true"></i>
    );
}

export default Adr;